// extracted by mini-css-extract-plugin
module.exports = {"actions_container":"actions_container--btCzN","button":"button--XUGnQ","dummye":"dummye--3osSG"};